export default {
  'lv5': [{
    data: [{
      id: 1,
      pic: '/static/images/ceshiti/early3/25.png',
      text:'Six ducklings went for a swim in the pond.'
    }, {
      id: 2,
      pic: '/static/images/ceshiti/early3/26.png',
      text:'Goodbye, said Mother Duck. Don’t get lost.'
    }, {
      id: 3,
      pic: '/static/images/ceshiti/early3/27.png',
      text:'Let me count. 1, 2, 3, 4, ,5!'
    }, {
      id: 4,
      pic: '/static/images/ceshiti/early3/28.png',
      text:'Mother Duck came to look for her six ducklings.'
    }, {
      id: 5,
      pic: '/static/images/ceshiti/early3/29.png',
      text:'1, 2, 3, ,4, 5, 6! You are all here now. No one is lost.'
    },],
    answer: [1, 2, 3, 4, 5]
  },{
    data: [{
      id: 1,
      pic: '/static/images/ceshiti/early3/30.png',
      text:'We can get clean like this. Splash, splash, splash!'
    }, {
      id: 2,
      pic: '/static/images/ceshiti/early3/31.png',
      text:'We will get clean like this. Scratch, scratch, scratch!'
    }, {
      id: 3,
      pic: '/static/images/ceshiti/early3/32.png',
      text:'We will get clean like this. Swim, swim, swim!'
    }, {
      id: 4,
      pic: '/static/images/ceshiti/early3/33.png',
      text:'We can get clean like this. Shake, shake, shake!'
    }, {
      id: 5,
      pic: '/static/images/ceshiti/early3/34.png',
      text:'We will get clean like this. Roll, roll, roll!'
    },],
    answer: [1, 2, 3, 4, 5]
  },{
    data: [{
      id: 1,
      pic: '/static/images/ceshiti/early3/35.png',
      text:'“I can’t go outside to play,” he said. “I feel grumpy.”'
    }, {
      id: 2,
      pic: '/static/images/ceshiti/early3/36.png',
      text:'“Don’t smile, Sam,” said Sue.'
    }, {
      id: 3,
      pic: '/static/images/ceshiti/early3/37.png',
      text:'Kate made a funny face, but Sam wouldn’t laugh.'
    }, {
      id: 4,
      pic: '/static/images/ceshiti/early3/38.png',
      text:'Grandma put on Sam’s gorilla mask.'
    }, {
      id: 5,
      pic: '/static/images/ceshiti/early3/39.png',
      text:'I don’t feel grumpy now.'
    },],
    answer: [1, 2, 3, 4, 5]
  },{
    data: [{
      id: 1,
      pic: '/static/images/ceshiti/early3/40.png',
      text:'A big boat sailed past.'
    }, {
      id: 2,
      pic: '/static/images/ceshiti/early3/41.png',
      text:'Motorbikes make too much noise.'
    }, {
      id: 3,
      pic: '/static/images/ceshiti/early3/42.png',
      text:'Grandpa went to sleep. Zzz!'
    }, {
      id: 4,
      pic: '/static/images/ceshiti/early3/43.png',
      text:'A big plane flew past.'
    }, {
      id: 5,
      pic: '/static/images/ceshiti/early3/44.png',
      text:'Trains make too much noise.'
    },],
    answer: [1, 2, 3, 4, 5]
  },{
    data: [{
      id: 1,
      pic: '/static/images/ceshiti/early3/45.png',
      text:'She had a bag of bread for the ducks.'
    }, {
      id: 2,
      pic: '/static/images/ceshiti/early3/46.png',
      text:'She gave a piece of bread to the mouse.'
    }, {
      id: 3,
      pic: '/static/images/ceshiti/early3/47.png',
      text:'She gave two pieces of bread to the birds.'
    }, {
      id: 4,
      pic: '/static/images/ceshiti/early3/48.png',
      text:'Beth saw four rabbits.'
    }, {
      id: 5,
      pic: '/static/images/ceshiti/early3/49.png',
      text:'Beth looked in her bag.'
    },],
    answer: [1, 2, 3, 4, 5]
  },{
    data: [{
      id: 1,
      pic: '/static/images/ceshiti/early3/50.png',
      text:'One day she saw a snake coming out of the grass.'
    }, {
      id: 2,
      pic: '/static/images/ceshiti/early3/51.png',
      text:'One day she saw a whale coming out of the sea.'
    }, {
      id: 3,
      pic: '/static/images/ceshiti/early3/52.png',
      text:'One day she saw a spider coming out of its web.'
    }, {
      id: 4,
      pic: '/static/images/ceshiti/early3/53.png',
      text:'One day she saw a mouse coming out of its hole.'
    }, {
      id: 5,
      pic: '/static/images/ceshiti/early3/54.png',
      text:'One day she saw a crocodile coming out of the river.'
    },],
    answer: [1, 2, 3, 4, 5]
  },{
    data: [{
      id: 1,
      pic: '/static/images/ceshiti/early3/55.png',
      text:'Tom went to the beach to ride on his surfboard.'
    }, {
      id: 2,
      pic: '/static/images/ceshiti/early3/56.png',
      text:'Tom went to the park to ride on his skateboard.'
    }, {
      id: 3,
      pic: '/static/images/ceshiti/early3/57.png',
      text:'Tom went for a ride on his snowboard.'
    }, {
      id: 4,
      pic: '/static/images/ceshiti/early3/58.png',
      text:'He jumped onto the snowboard for a ride with Tom.'
    }, {
      id: 5,
      pic: '/static/images/ceshiti/early3/59.png',
      text:' Tom went to the farm to have a ride on a tractor.'
    },],
    answer: [1, 2, 3, 4, 5]
  },{
    data: [{
      id: 1,
      pic: '/static/images/ceshiti/early3/60.png',
      text:'On Saturday, I got a pear from the fruit bowl.'
    }, {
      id: 2,
      pic: '/static/images/ceshiti/early3/61.png',
      text:'On Monday morning, I got an apple to take to school.'
    }, {
      id: 3,
      pic: '/static/images/ceshiti/early3/62.png',
      text:'I love bananas. Yum!.'
    }, {
      id: 4,
      pic: '/static/images/ceshiti/early3/63.png',
      text:'On Thursday morning, I got some strawberries from the fruit bowl.'
    }, {
      id: 5,
      pic: '/static/images/ceshiti/early3/64.png',
      text:'I forgot to take my snack to school.'
    },],
    answer: [1, 2, 3, 4, 5]
  },{
    data: [{
      id: 1,
      pic: '/static/images/ceshiti/early3/65.png',
      text:'We went to the river to have a swim.'
    }, {
      id: 2,
      pic: '/static/images/ceshiti/early3/66.png',
      text:'I swim in this sea too, said Dolphin..'
    }, {
      id: 3,
      pic: '/static/images/ceshiti/early3/67.png',
      text:'We went to have a swim at the beach.'
    }, {
      id: 4,
      pic: '/static/images/ceshiti/early3/68.png',
      text:'I swim here said Frog.'
    }, {
      id: 5,
      pic: '/static/images/ceshiti/early3/69.png',
      text:'Come in for a swim in the pool.'
    },],
    answer: [1, 2, 3, 4, 5]
  },{
    data: [{
      id: 1,
      pic: '/static/images/ceshiti/early3/70.png',
      text:'I wiggled it with my finger.'
    }, {
      id: 2,
      pic: '/static/images/ceshiti/early3/71.png',
      text:'I showed it to my father.'
    }, {
      id: 3,
      pic: '/static/images/ceshiti/early3/72.png',
      text:'My tooth came out at school.'
    }, {
      id: 4,
      pic: '/static/images/ceshiti/early3/73.png',
      text:'She got a box for it.'
    }, {
      id: 5,
      pic: '/static/images/ceshiti/early3/74.png',
      text:'Your new tooth is growing now.'
    },],
    answer: [1, 2, 3, 4, 5]
  },]
}



// WEBPACK FOOTER //
// ./src/testdata/put.js